import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export type DashboardRequestKind =
  | 'pricing'
  | 'profile'
  | 'battery'
  | 'po'
  | 'message'
  | 'project';

export interface DashboardRequestRow {
  id: string;
  kind: DashboardRequestKind;
  /** Uppercase category label, e.g. "PRICING REQUEST". */
  category: string;
  title: string;
  subtitle: string;
  /** Pre-formatted relative timestamp, e.g. "12m ago". */
  timestamp: string;
  actionLabel: string;
  actionVariant: 'primary' | 'ghost';
  /** Resolved navigation target (internal route or url). */
  targetLink: string;
}

/**
 * Presentational "open request" feed row: type icon, colored category label,
 * linked title, subtitle, timestamp and a single action button. Navigation is
 * delegated to the container via the `open` output.
 */
@Component({
  selector: 'em-dashboard-request-row',
  templateUrl: './dashboard-request-row.component.html',
  styleUrls: ['./dashboard-request-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardRequestRowComponent {
  readonly row = input.required<DashboardRequestRow>();
  readonly open = output<void>();
}
